import { AxiosResponse } from 'axios';
import { DocumentSerieForm } from 'civil-status/components/document-serie/form';
import { DocumentSerie } from 'shell/models/document-serie';
import { HttpResponse } from 'shell/models/http-response';

export const transformResponseDocumentSerie = (
  response: AxiosResponse<HttpResponse<DocumentSerie>>
): DocumentSerieForm => {
  const responseData = response.data.payload;
  return {
    number: responseData?.key?.codiceSerie || '',
    description: responseData?.serie || '',
  };
};
